import { createAction } from '@reduxjs/toolkit';

import { type ClipAndBoardListItem } from '@air/api/types';

import { type DndSortableKanbanItemData } from '~/types/DndKit';
import { type KanbanColumnsWithInitialData } from '~/types/KanbanData';

export const kanbanItemDragStartAction = createAction('KANBAN_ITEM_DRAG_START');

export const resetKanbanManagerAction = createAction('RESET_KANBAN_MANAGER');

export const kanbanItemDragCancelAction = createAction('KANBAN_ITEM_DRAG_CANCEL');

export const setGroupedItemsResponseInKanbanManagerAction = createAction<{
  columnsWithInitialData: KanbanColumnsWithInitialData;
}>('SET_GROUPED_ITEMS_RESPONSE_IN_KANBAN_MANAGER');

export const updateKanbanColumnWithNewDataAction = createAction<{
  columnsToUpdate: Record<string, { data: ClipAndBoardListItem[]; total: number | undefined }>;
  shouldSkipSWRSync?: boolean;
}>('UPDATE_KANBAN_COLUMN_WITH_NEW_DATA');

export const kanbanItemDragEndAction = createAction<{
  updatedColumnItems: Record<string, { data: DndSortableKanbanItemData[]; total: number }>;
}>('SET_UPDATED_KANBAN_COLUMN_ITEMS');

export const kanbanItemPositionSuccessAction = createAction('KANBAN_ITEM_POSITION_SUCCESS');

export const kanbanColumnFetcherSyncedAction = createAction<{ kanbanColumnId: string }>('KANBAN_COLUMN_FETCHER_SYNCED');

export const removeKanbanItemsAction = createAction<{ itemIds: string[] }>('REMOVE_KANBAN_ITEMS');
